export default "__VITE_ASSET__ClPzeEIy__"